module.exports = __webpack_public_path__ + "img/header-shape.ab54ecab.png";